import {CoilRequest} from './coil-request';

export class UnitRatingRequest {

  Airflow!: number;
  Altitude!: number;
  Model!: string;
  Size!: string;
  MotorConfiguration!: string;
  MotorType!: string;
  PrimaryCoilRequest!: CoilRequest;
  SecondaryCoilRequest!: CoilRequest;
  ElectricHeatRequest!: CoilRequest;
  Filter!: string;
  FanSpeed!: string;
  ExternalStaticPressure!: number;
  TotalStaticPressure!: number;
  IsMetricInput!: boolean;

}
